import React from 'react';
import { FloatLabel } from '../../../Components';
import SelectSectorWork from '../../../Components/SelectSectorWork/SelectSectorWork';

interface SectorPartialFormProps<T> {
    language: string;
    dictErrorSubmit: string;
    dictCommissionCompanyLabel: string;
    dictIdentificationCodeError: string;
    values: T;
    errors?: Partial<Record<keyof T, string>>;
    onSelectSector: (selection: { sector: string; work: string }) => void;
    onChangeCommission: (value: string) => void;
    onKeyDownNumber: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SectorPartialForm = <
    T extends {
        sectorCompany: string;
        workCompany: string;
        commissionCompany: string;
    },
>({
    language,
    dictErrorSubmit,
    dictCommissionCompanyLabel,
    values,
    errors,
    onSelectSector,
    onChangeCommission,
    onKeyDownNumber,
}: SectorPartialFormProps<T>) => {
    const normalizedLang = language === 'nl' ? 'nl' : 'fr';
    return (
        <div className="row mt-2">
            <div className="col-12">
                <SelectSectorWork
                    language={normalizedLang}
                    onSelectionChange={onSelectSector}
                />

                {(errors?.sectorCompany || errors?.workCompany) && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-12 mt-3">
                <FloatLabel
                    active={!!values.commissionCompany}
                    label={dictCommissionCompanyLabel}
                    labelId="commissionCompany"
                >
                    <input
                        type="text"
                        name="commissionCompany"
                        value={values.commissionCompany}
                        onChange={(e) => onChangeCommission(e.target.value)}
                        onKeyDown={onKeyDownNumber}
                    />
                </FloatLabel>
                {errors?.commissionCompany && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {errors.commissionCompany}
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SectorPartialForm;
